import type { CrmProviderType } from './types';

const PROVIDER_ACCOUNT_DOMAINS: Partial<Record<CrmProviderType, string>> = {
  kommo: 'kommo.com',
  salesdrive: 'salesdrive.me',
};

export function formatCrmAccountHost(
  provider: CrmProviderType,
  subdomain: string,
): string {
  const accountDomain = PROVIDER_ACCOUNT_DOMAINS[provider];
  return accountDomain ? `${subdomain}.${accountDomain}` : subdomain;
}
